<div [formGroup]="themeForm" class="text-small text-center">
    <select formControlName="theme" class="custom-select custom-select-sm form-control-secondary form-control mx-auto" (change)="changeTheme()">
        <option value="default" i18n="mempool-goggles.classic">Classic</option>
        <option value="contrast">BlueMatt</option>
        <option value="wiz">wiz</option>
    </select>
</div>
